import React from 'react'

const FilterByAssistant = ({ selectedFilter, setSelectedFilter }) => {
    const filters = ['Rec', 'Inst', 'All'];

    return (
      <div className="assistant-filter">
        {filters.map((filter) => (
          <span
            key={filter}
            className={selectedFilter === filter ? 'selected' : ''}
            onClick={() => setSelectedFilter(filter)}
          >
            {filter}
          </span>
        ))}
      </div>
    );
  };

export default FilterByAssistant

// When selecting 'Today' it doesn't grab the day's records, 
// but if I manually change the date to the day before in the lookup it will appear. 
// So the date range filter is incorrectly bringing back records.